import { Injectable, EventEmitter, OnDestroy } from '@angular/core';
import { NotifyModel, NotifyType } from './notifyModel';
import { Utility } from '../utility';
import { environment } from '../../../environments/environment';
import { SocketIOService } from '../socket/socketio.service';
import { Observable, BehaviorSubject, Subscription } from 'rxjs';

@Injectable()
export class NotifyService implements OnDestroy {
  public isEnable = true;//environment.app;
  // private socket: SocketIOClient.Socket;
  private observers: Array<ActionObserve> = [];
  public onnect: EventEmitter<any> = new EventEmitter<any>();
  public ondisconneted: EventEmitter<any> = new EventEmitter<any>();
  private socket;
  public isconnected = false;
  private lastRoom = null;
  private connectionHash = null;
  private reconnecting = false;
  private isauth = false;
  private isInit = false;
  public isLogin = false;
  private uid = 0
  subscriptions: Array<Subscription> = [];
  constructor(
    private _socketIO: SocketIOService
  ) {
    // if (!environment.disableNotify)
    //   this.init(0);
  }

  public init(uid) {
    this.uid = uid;
    if (!this.isEnable || !this.isLogin || (!!this.socket && this.socket.ioSocket.connected)) {
      return;
    }
    this._socketIO.getOrCreateSocket(this.uid).then(socket => {
      this.socket = socket;
      this.socket.on("connect", () => {
        this.isconnected = true;
        if (this.connectionHash != null) {
          this.reconnecting = true;
          if (this.lastData != null) {
            //console.debug("reconencted");
            this.authorize(this.lastData);
          }
          console.debug("user data connected");
        }

        var rehash = Math.random();
        this.observers.forEach(p => {
          if (p.hash != rehash) {
            this.socket.removeListener(p.name);///重新连接后，需要卸载监听，重新监听
            //p.observer.
            this.socket.on(p.name, (msg) => {
              //console.log(msg);
              p.observer.next(msg)
            });
            p.hash = rehash
          }
        })
        // console.debug("socket server connected")
        this.connectionHash = rehash;
        this.onnect.next("connected");
      });

      this.socket.on("disconnect", p => {
        console.debug("server may restarted", p);
        this.isconnected = false;
        this.ondisconneted.next();
        //this.socket.close();
        //this.socket = null;
      });

      if (!this.isInit) {
        this.isInit = true;
        this.on({
          action: NotifyType.Conn
        }).subscribe(p => {
          //  console.log("authorize",this.eventToSend);

          this.eventToSend.forEach(p => {
            //  console.log(p)
            this.sendMsg(p);
          });
          this.eventToSend = [];
          console.debug("user authorize", p);

          //console.log(p,this.lastRoom);
          if (p && p.length > 0 && p[0] == "ok") {
            //console.log("user login")
            this.isauth = true;
            this.onAuthorized();

          }
        });
      }
    })



  }
  /*
  ** 用户通过验证
  */
  private onAuthorized() {
    //console.log(this.lastRoom)
    if (this.lastRoom != null) {
      this.socket.emit(NotifyType.JoinVideoRoom, this.lastRoom);

    }
  }

  private info(str) {
    console.debug("notifyService", str);
  }

  private lastData = null;
  private eventToSend: Array<NotifyModel> = [];

  /*
  ** 清除用户数据
  */
  clear() {
    this.lastData = null;
    if (this.socket != null && this.socket.ioSocket.connected) {
      // console.log("user disconnect")
      this.socket.disconnect();
    }
    //console.debug("clear user state");
  }
  //验证用户,前端逻辑验证一次，此通知服务会记录用户信息，重新连接时，用此信息重新验证。
  authorize(obj: any) {
    this.lastData = obj;
    this.sendMsg({
      action: NotifyType.Conn,
      data: obj
    });
    console.debug("authorize user")
    // this.socket.emit("conn",obj);
  }

  //发送消息
  sendMsg(obj: NotifyModel) {
    // console.log(this.isconnected,obj);
    if (this.isEnable) {
      if (this.isconnected) {
        this.socket.emit(obj.action, obj.data);
      }
      else {
        if (obj.action != NotifyType.Conn
          && obj.action != NotifyType.LeaveVideoRoom
          && obj.action != NotifyType.JoinVideoRoom
        ) {
          this.eventToSend = this.eventToSend.filter(p => p.action != obj.action);
          this.eventToSend.push(obj);
          //console.log(this.eventToSend)
        }
      }

      switch (obj.action) {
        case NotifyType.JoinVideoRoom:
          this.lastRoom = obj.data;
          break;
        case NotifyType.LeaveVideoRoom:
          this.lastRoom = null;
          break;
      }
      //console.log(this.lastRoom);
    }

  }

  //监听消息
  on(obj: NotifyModel): EventEmitter<any> {

    var data = this.observers.find(p => p.name == obj.action);
    if (data == null) {
      data = new ActionObserve();
      data.name = obj.action;
      data.observer = new EventEmitter<any>();
      this.observers.push(data);

    }

    if (data.hash != this.connectionHash) {
      data.hash = this.connectionHash;
      this.socket.on(obj.action, msg => {
        data.observer.next(msg);
      })
    }
    // else
    // {
    //    if(this.isEnable)
    //    {
    //        this.socket.on(obj.action,msg =>{
    //         //console.log(msg);
    //         data.notifier.next(msg);
    //        })
    //    }
    // }
    return data.observer;
    // //console.log("conn",obj.action,"conn" == obj.action)
    // return Observable.create(observable=>{
    //   if(this.isEnable)
    //   {
    //     this.socket.on(obj.action,msg=>{
    //       observable.next(msg);
    //     })
    //   }

    // })
  }

  //   // EMITTER
  //   sendMessage(msg: string) {
  //     this.socket.emit('sendMessage', { message: msg });
  //   }

  //   // HANDLER
  //   onNewMessage() {
  //     return Observable.create(observer => {
  //       this.socket.on('newMessage', msg => {
  //         observer.next(msg);
  //       });
  //     });
  //   }

  // 非通知消息使用，发送socket
  emit(event: string, data?: any) {
    // console.group();
    // console.log('----- SOCKET OUT -----');
    // console.log('Action: ', event);
    // console.log('Payload: ', data);
    // console.groupEnd();
    if (this.socket) {
      this.socket.emit(event, data);
    }
  }

  // 非通知消息使用，监听socket
  listen(action): Observable<any> {
    const callback = this.listenFromService(
      {action: action,}
    );
    this.subscriptions.push(
      callback.subscribe(res => {
        // console.group();
        // console.log('----- SOCKET IN -----');
        // console.log('Action: ', action);
        // console.log('Payload: ', res);
        // console.groupEnd();
      })
    );
    return callback;
  }

  listenFromService(obj): EventEmitter<any> {
    var data = this.observers.find(p => p.name == obj.action);
    if (data == null) {
      data = new ActionObserve();
      data.name = obj.action;
      data.observer = new EventEmitter<any>();
      this.observers.push(data);
    }
    if (data.hash != this.connectionHash) {
      data.hash = this.connectionHash;
      this.socket.on(obj.action, msg => {
        data.observer.next(msg);
      })
    }
    return data.observer;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}


class ActionObserve {
  public name: string;
  public observer: EventEmitter<any>;
  public notifier: any;
  public hash: any;
}
